import { getVisit } from './init';
import { getTransactionId } from './transactionID';

const baseRequest = () => {
  const href = document.location.href;
  const { bookingId, searchId, membershipId } = getTransactionId();
  const browserTimestamp = new Date().getTime();
  return {
    visitId: getVisit(),
    bookingId,
    searchId,
    membershipId,
    href,
    browserTimestamp,
  };
};

export const buildPageLoadedRequest = (
  mktSessionId,
  previousPageRenderId,
  pageRenderId,
  mfe = {}
) => {
  const referrer = window.document.referrer;
  return Object.assign(
    {
      mktSessionId,
      referrer,
      pageRenderId,
      previousPageRenderId,
      microFrontendName: mfe.name,
      microFrontendVersion: mfe.version,
    },
    baseRequest()
  );
};

export const buildClickRequest = (htmlElementId, pageRenderId) =>
  Object.assign({ htmlElementId, pageRenderId }, baseRequest());

export const buildDisplayedRequest = (componentId, pageRenderId) =>
  Object.assign({ componentId, pageRenderId }, baseRequest());
